export const options = state => state.adminReducer.user.permissions.options

export const isLoading = state => state.adminReducer.user.permissions.isLoading

export const isSuccess = state => state.adminReducer.user.permissions.isSuccess

export const permissions = state => state.adminReducer.user.permissions.permissions
